import React, { useState, useEffect } from 'react'
import { useHistory, withRouter, Redirect } from 'react-router-dom'
import { routes } from '../../../../constantes/routes'
import ContactModal from '../ContactModal'
import { swalAlertError, swalSuccessGeneral } from '../../../../utils/swalAlert'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import { useDispatch, useSelector } from 'react-redux'
import { contactsActions } from '../../../../actions/contactsActions'
import { businessunitsActions } from '../../../../actions/businessunitsActions'
import validators from '../../../../utils/validationsRegEx'
import { swalTitle } from '../../../../constantes/swalTitle'
import { swalMssgs } from '../../../../constantes/swalMssgs'

const NewContactContainer = () => {
  const history = useHistory()
  const dispach = useDispatch()
  const userProfile = useSelector((state) => state.userProfile)
  const businessunits = useSelector((state) => state.businessunits)

  const newContact = (contact) => dispach(contactsActions.newContact(contact))
  const getAllBusinessUnits = () =>
    dispach(businessunitsActions.getAllBusinessUnits())

  const [inputs, setinputs] = useState({
    nombre: '',
    telf: '',
    observaciones: '',
    email: '',
    fechaNacimiento: '',
    id_Evento: '',
    businessUnits: [],
    id_Hospitales: '',
    id_Departamentos: '',
    id_Especialidades: '',
    id_TipoCargo: '',
    isCheckedLGPD: false,
  })
  const [isDisable, setIsDisable] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(true) // Modal abierto por defecto

  useEffect(() => {
    getAllBusinessUnits()
  }, [])

  const closeModal = () => {
    setModalIsOpen(false)
    history.push(routes.CONTACTS)
  }

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setinputs((inputs) => ({ ...inputs, [name]: value }))
    if (name === 'telf') setinputs((inputs) => ({ ...inputs, Telefono: value }))
  }

  const handleSubmitToCreateContact = async (event) => {
    event.preventDefault()
    setIsDisable(true)
    try {
      // Transformar businessUnits a id_NegocioUnidades para el backend
      const { businessUnits, isCheckedLGPD, ...contactDataBase } = inputs
      const contactData = {
        ...contactDataBase,
        Telefono: inputs.telf,
        id_NegocioUnidades: businessUnits || [], // businessUnits ya son IDs directamente
        // Convertir a arrays como especifica el backend (int[])
        id_Hospitales: inputs.id_Hospitales
          ? [parseInt(inputs.id_Hospitales)]
          : [],
        id_Departamentos: inputs.id_Departamentos
          ? [parseInt(inputs.id_Departamentos)]
          : [],
        id_Especialidades: inputs.id_Especialidades
          ? [parseInt(inputs.id_Especialidades)]
          : [],
        id_TipoCargo: inputs.id_TipoCargo
          ? [parseInt(inputs.id_TipoCargo)]
          : [],
      }

      await newContact(contactData).then((data) =>
        history.push(
          routes.CONTACTS_ADD_HOSPITAL_TO_CONTACT + data.payload.id_Contacto,
        ),
      )
      closeModal()
      swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
    } catch (error) {
      swalAlertError(error?.payload)
      setIsDisable(false)
    }
  }

  const validateForm = () => {
    return (
      validators.hasValue(inputs.nombre) &&
      ( !validators.hasValue(inputs.telf) || validators.phoneNumberFormat(inputs.telf) ) &&
      validators.emailFormat(inputs.email) &&
      inputs.businessUnits.length > 0 &&
      validators.hasValue(inputs.id_Especialidades) &&
      validators.hasValue(inputs.id_Hospitales) &&
      validators.hasValue(inputs.id_Departamentos) &&
      validators.hasValue(inputs.id_TipoCargo) &&
      inputs.isCheckedLGPD === true
    )
  }

  return (
    <>
      {userProfile.roles ? (
        <div className='products'>
          <ContactModal
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
            inputs={inputs}
            handleChange={handleChange}
            handleSubmit={handleSubmitToCreateContact}
            validateForm={validateForm}
            textBtn={onSubmitText.Siguiente}
            businessunits={businessunits}
            isEdit={false}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}

    </>
  )
}

export default withRouter(NewContactContainer)
